export function getShortlistedUISettings(campaignUISettingsShorlistedVisibility = {}) {
  return {
    channels: (campaignUISettingsShorlistedVisibility.channels || []).reduce((result, channel) => {
      // eslint-disable-next-line no-param-reassign
      result[channel.type] = channel.visible;
      return result;
    }, {}),
    columns: (campaignUISettingsShorlistedVisibility.columns || []).reduce((result, column) => {
      // eslint-disable-next-line no-param-reassign
      result[column.type] = column.visible;
      return result;
    }, {})
  };
}
